import React from 'react';
import ReactDOM from 'react-dom';
import OnboardingComplete from '../components/OnboardingComplete.component';

angular
  .module('success')
  .directive('onboardingComplete', onboardingCompleteDirective);

/* @ngInject */
function onboardingCompleteDirective() {
  return {
    restrict: 'E',
    link(scope, element) {
      ReactDOM.render(React.createElement(OnboardingComplete), element[0]);

      scope.$on('$destroy', () => {
        ReactDOM.unmountComponentAtNode(element[0]);
      });
    },
  };
}
